export const isFiscalInterval = (
  interval: FiscalInterval | FleetOps.Interval,
): interval is FixedPeriods.FiscalType =>
  ['fiscalPeriod', 'fiscalQuarter', 'fiscalYear'].includes(interval);

export const isCalendarInterval = (
  interval: FiscalInterval | FleetOps.Interval,
): interval is CalendarInterval =>
  ['day', 'week', 'month', 'quarter', 'year'].includes(interval);

export const isCalendarWithAutoInterval = (
  interval: FiscalInterval | FleetOps.Interval,
): interval is FleetOps.Interval =>
  ['auto', 'day', 'week', 'month', 'quarter', 'year'].includes(interval);

export const isSameIntervalType = (
  interval1: FiscalInterval | FleetOps.Interval,
  interval2: FiscalInterval | FleetOps.Interval,
) => {
  // Week interval compatible with both calendar and fiscal intervals
  if (interval1 === 'week' || interval2 === 'week') {
    return true;
  }
  return (
    (isCalendarInterval(interval1) && isCalendarInterval(interval2)) ||
    (isFiscalInterval(interval1) && isFiscalInterval(interval2))
  );
};

const relativeDateRangeTypeCheckers = {
  isSameIntervalType,
  isFiscalInterval,
  isCalendarInterval,
  isCalendarWithAutoInterval,
};

export default relativeDateRangeTypeCheckers;
